import { Stack, Box } from '@mui/material';

import { IExtraCategoryValueFragment } from 'graphql/types';
import { InfoRow } from 'common/components/InfoRow';
import { groupCategoryValuesByCategoryName } from 'organisation/utils/extraCategory';

interface IProps {
    extraCategoryValues: IExtraCategoryValueFragment[];
}

export const ExtraCategoryInfo = ({ extraCategoryValues }: IProps) => {
    if (!extraCategoryValues.length) return null;

    const categoryGroups =
        groupCategoryValuesByCategoryName(extraCategoryValues);

    return (
        <Stack spacing={2}>
            {Object.entries(categoryGroups).map(
                ([categoryName, categoryValues]) => (
                    <InfoRow description={categoryName} key={categoryName}>
                        <Stack>
                            {categoryValues.map((value) => (
                                <Box key={value.id + value.label}>
                                    {value.label}
                                </Box>
                            ))}
                        </Stack>
                    </InfoRow>
                )
            )}
        </Stack>
    );
};
